module.exports = __webpack_public_path__ + "static/media/clients_on@2x.48c20bcc.svg";